import { css } from "lit";
export default css `
    
    h2 {
        color: var(--secondary-color);
        text-align: center;
        text-shadow: 0 0 20px var(--secondary-color);
    }
    
    .logo-container {
        width: calc(100% - 200px);
        height: calc(100% - 12px);
        margin-left: 100px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        overflow-y: auto;
        justify-content: space-evenly;
    }

    .logo {
        width: 200px;
        padding: 0 40px 0 40px;
    }
    
    svg {
        overflow: visible;
        transition: filter 300ms ease-in-out;
       
    }

    svg:hover {
        animation: pulse-glow 300ms infinite alternate;
        filter: drop-shadow(0 0 20px var(--primary-color));
    }

    @keyframes pulse-glow {
        0% {
            filter: drop-shadow(0 0 10px var(--primary-color));
        }
        100% {
            filter: drop-shadow(0 0 10px var(--primary-color-lowalpha));
        }
    }
    
    @media only screen and (max-width: 1280px) {
        .logo {
            width: 120px;
        }

        .logo-container {
            width: calc(100% - 50px);
            margin-left: 25px;
        }
    }


    @media only screen and (max-width: 500px) {
        .logo {
            width: 100px;
        }

        .logo-container {
            width: 100%;
            margin-left: 0;
        }
    }
    
    
`;
